import {Component, Input, OnInit} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import * as _ from 'lodash';

@Component({
  selector: 'app-read-service-table',
  templateUrl: './read-service-table.component.html',
  styleUrls: ['./read-service-table.component.css']
})
export class ReadServiceTableComponent implements OnInit {

  @Input() oneComponent: any;
  @Input() componentIndex: any;
  @Input() oneSmallGroup: any;
  @Input() smallGroupIndex: any;
  @Input() groupIndex: any;
  @Input() serviceData: any;
  componentModalVisible: any;
  componentDatas = {};

  constructor() {
  }

  ngOnInit() {
  }


}
